<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" class="spinner">
    <circle class="outer" cx="50" cy="50" r="40" stroke="#3498db" stroke-width="10" stroke-linecap="round" fill="none"
        stroke-dasharray="126.92" stroke-dashoffset="63.46" />
    <circle class="middle" cx="50" cy="50" r="30" stroke="#e74c3c" stroke-width="10" stroke-linecap="round" fill="none"
        stroke-dasharray="94.25" stroke-dashoffset="47.12" />
    <circle class="inner" cx="50" cy="50" r="20" stroke="#f1c40f" stroke-width="10" stroke-linecap="round" fill="none"
        stroke-dasharray="62.83" stroke-dashoffset="31.42" />
</svg>